import { render, staticRenderFns } from "./RoleData.vue?vue&type=template&id=569f55b8&scoped=true&"
import script from "./RoleData.vue?vue&type=script&lang=js&"
export * from "./RoleData.vue?vue&type=script&lang=js&"
import style0 from "./RoleData.vue?vue&type=style&index=0&id=569f55b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f55b8",
  null
  
)

export default component.exports